import { Children, isValidElement, type ReactNode, useState } from 'react'

import { isNonNullable } from '@subaio/utils'

import { ButtonGroup } from './ButtonGroup'
import { ButtonTab } from './ButtonTab'
import { CodeBlock } from './CodeBlock'
import { Container } from './Container'

type Props = {
	children: ReactNode
}

export const CodeTabs = ({ children }: Props) => {
	// This is done to support markdown code blocks with titles, do not do this otherwise if you can avoid it
	const parts = Children.toArray(children)
	const codeExamples = parts
		.map((child, index) => {
			if (typeof child === 'object' && 'type' in child && child.type && child.type === 'pre') {
				const potentialTitle = index !== 0 ? parts[index - 1] : null
				const title = isValidElement(potentialTitle) && potentialTitle.type === 'p' ? potentialTitle : null
				return {
					children: child,
					title: title?.props?.children as ReactNode,
					index,
				}
			}
			return null
		})
		.filter(isNonNullable)

	const [selectedIndex, setSelectedIndex] = useState(0)

	if (codeExamples.length === 0) return null

	return (
		<Container>
			<ButtonGroup>
				{codeExamples.map(({ title }, index) => (
					<ButtonTab
						key={index}
						isActive={index === selectedIndex}
						disabled={selectedIndex === index}
						onClick={() => setSelectedIndex(index)}
					>
						{title ?? `File ${index + 1}`}
					</ButtonTab>
				))}
			</ButtonGroup>
			<CodeBlock>{codeExamples[selectedIndex].children}</CodeBlock>
		</Container>
	)
}
